/**
 * List of items to be displayed within the model dropdown.
 */
export const dummyModelItems = [
  { id: '1', title: 'Durward Reynolds', checked: false },
  { id: '2', title: 'Kenton Towne', checked: false },
  { id: '3', title: 'Therese Wunsch', checked: false },
  { id: '4', title: 'Benedict Kessler', checked: false },
  { id: '5', title: 'Katelyn Rohan', checked: false },
  { id: '6', title: 'Reynolds', checked: false },
  { id: '7', title: 'Kenton', checked: false },
  { id: '8', title: 'Wunsch', checked: false },
  { id: '9', title: 'Benedict', checked: false },
  { id: '10', title: 'Test 1', checked: false },
  { id: '11', title: 'Test 2', checked: false },
  { id: '12', title: 'Test 3', checked: false },
  { id: '13', title: 'Test 4', checked: false },
  { id: '14', title: 'Test 5', checked: false },
  { id: '15', title: 'Test 6', checked: false },
];

/**
 * List of items to be displayed within the device dropdown.
 * TODO: Get these items from the API request
 */
export const dummyDeviceDropDownItems = [
  { id: '1', title: 'Select Device' },
  { id: '2', title: 'Smartphone' },
  { id: '3', title: 'Laptop' },
  { id: '4', title: 'Smartwatch' },
  { id: '5', title: 'Tablet' },
];

/**
 * List of items to be displayed within the device dropdown.
 * TODO: Get these items from the API request
 */
export const dummySimpleMultiSelectItems = [
  { id: '1', title: 'Durward Reynolds' },
  { id: '2', title: 'Kenton Towne' },
  { id: '3', title: 'Therese Wunsch' },
  { id: '4', title: 'Benedict Kessler' },
  { id: '5', title: 'Katelyn Rohan' },
];

export const dummyDropdownItems = [
  {
    title: 'Mobile Phones',
    id: '1',
    checked: false,
  },
  {
    title: 'Laptops',
    id: '2',
    checked: false,
  },
  {
    title: 'Smart Watches',
    id: '3',
    checked: false,
  },
];
